import { render } from "./HumanCapital.vue?vue&type=template&id=3ffe9a56&scoped=true"
import script from "./HumanCapital.vue?vue&type=script&lang=js"
export * from "./HumanCapital.vue?vue&type=script&lang=js"

import "./HumanCapital.vue?vue&type=style&index=0&id=3ffe9a56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ffe9a56"]])

export default __exports__